import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { HomePageURL } from '../assets/const';
import OrderList from '../pages/orders/OrderList';
import OrderDetail from '../pages/orders/OrderDetail';

const OrderRoute = () => {
    return (
        <Routes>
            <Route path={`${HomePageURL}/orders/`} element={<OrderList/>} />
            <Route path={`${HomePageURL}/orders/:orderId/`} element={<OrderDetail/>} />
        </Routes>
    )
}

export default OrderRoute;